/**
 * スムーススクロールリンク
 */

import { scroll } from '../components/scroll';

function scrollTo(targetId, duration) {
    const header = document.querySelector('.section-site-header');
    const offset = header.getBoundingClientRect().height;

    scroll.scrollTo(
        targetId,
        { offset: -offset, duration: (duration === undefined) ? 100 : duration }
    );
}

export default {
    init: function () {
        document.querySelectorAll('[data-scrollto]').forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();

                scrollTo(link.getAttribute('href'), 100);
            });
        })
    },
    scrollTo: scrollTo,
};
